{
  "name": "collins-next",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-okku": "ng serve --configuration=okku --port=4301",
    "start-rojepp": "ng serve --configuration=rojepp --port=4301",
    "samuel": "ng serve --configuration=samuel --port=4301",
    "start-david": "ng serve --configuration=david --port=4301",
    "localprod": "ng serve --configuration=localprod --port=4301",
    "beta": "ng serve --configuration=beta --port=4301",
    "start-beta-localnet": "ng serve --host 0.0.0.0 --configuration=beta --port=4301",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "gc": "ng generate component --standalone --inline-template --inline-style --skip-tests --flat",
    "e2e": "playwright test",
    "e2e:iphone": "playwright test --project=iphone"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/fire": "^18.0.1",
    "@angular/forms": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@bambora/wallet": "^3.2.1",
    "@fortawesome/fontawesome-pro": "^6.7.2",
    "canvas-confetti": "^1.9.3",
    "firebase": "^11.3.1",
    "moment": "^2.30.1",
    "rxjs": "~7.8.0",
    "tailwindcss-primeui": "^0.3.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.12",
    "@angular/cli": "^18.2.12",
    "@angular/compiler-cli": "^18.2.0",
    "@playwright/test": "^1.49.1",
    "@types/applepayjs": "^14.0.8",
    "@types/canvas-confetti": "^1.9.0",
    "@types/googlepay": "^0.7.5",
    "@types/jasmine": "~5.1.0",
    "autoprefixer": "^10.4.20",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.49",
    "tailwindcss": "^3.4.16",
    "typescript": "~5.5.2"
  }
}
